export default __webpack_public_path__ + "static/media/arrow_toggle_down.f949572e.svg";